import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 32px;
`;

export const AppointmentDetailsWrapper = styled.div`
  h3 + div {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 24px !important;
    flex-direction: unset !important;
    align-items: flex-start !important;
    flex-wrap: unset !important;

    @media (max-width: 768px) {
      grid-template-columns: 1fr !important;
    }
  }
`;
